import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["onChange", "onSearch", "multiple", "options", "value", "emptyOption", "treeProps"];
import React, { useState, useEffect } from 'react';
import SearchTagInput from './SearchTagInput';
import Tree from '@uiw/react-tree';
import TreeChecked from '@uiw/react-tree-checked';
import { jsx as _jsx } from "react/jsx-runtime";
// type TreeCheckedsProps = TreeCheckedProps & Partial<DropContent<SearchTagInputOption>>
function TreeCheckeds(props) {
  var [selectOption, selectOptionSet] = useState({});
  var [keys, keysSet] = useState([]);
  useEffect(() => {
    var _props$values;
    var selectOption = {};
    var keys = (_props$values = props.values) == null ? void 0 : _props$values.map(opt => {
      selectOption[opt.key] = opt.label;
      return opt.key;
    });
    selectOptionSet(selectOption);
    keysSet(keys || []);
  }, [props.values]);
  var onSelected = (_, item, isChecked, evn) => {
    var curSelectOption = getOptionsRecursion([evn], selectOption, isChecked);
    var isNumberKey = false;
    if (typeof item === 'number') isNumberKey = true;
    var option = Object.entries(curSelectOption).map(_ref => {
      var [key, label] = _ref;
      return {
        key: isNumberKey ? Number.parseInt(key) : key,
        label
      };
    });
    props.onSelected == null || props.onSelected(option, {
      key: evn.key,
      label: evn.label
    }, isChecked);
  };
  var getOptionsRecursion = (childrens, selectOption, isAdd) => {
    var addOrDel = (key, label, isAdd) => {
      if (isAdd) {
        selectOption[key] = label;
      } else {
        delete selectOption[key];
      }
    };
    var iteratorParent = child => {
      // 向上迭代
      if (child.parent) {
        var selectCount = child.parent.children.filter(child => !selectOption[child.key]).length;
        addOrDel(child.parent.key, child.parent.label, selectCount === 0);
        iteratorParent(child.parent);
      }
    };
    childrens.forEach(child => {
      var _child$children, _child$label;
      if (!!((_child$children = child.children) != null && _child$children.length)) {
        selectOption = getOptionsRecursion(child.children, selectOption, isAdd);
      }
      addOrDel(child.key, (_child$label = child.label) == null ? void 0 : _child$label.toString(), isAdd);
      iteratorParent(child);
    });
    return selectOption;
  };
  return /*#__PURE__*/_jsx(TreeChecked, _extends({
    defaultExpandAll: true
  }, props, {
    data: props.options,
    selectedKeys: keys,
    onSelected: onSelected
  }));
}
function SingeTree(props) {
  var [keys, keysSet] = useState([]);
  useEffect(() => {
    var _props$values2;
    var keys = [];
    if ((_props$values2 = props.values) != null && _props$values2.length) keys[0] = props.values[0].key;
    keysSet(keys);
  }, [props.values]);
  var onSelected = (_1, _2, isChecked, evn) => {
    var {
      key,
      label
    } = evn;
    var cur = {
      key,
      label
    };
    props.onSelected == null || props.onSelected(isChecked ? [cur] : [], cur, isChecked);
  };
  return /*#__PURE__*/_jsx(Tree, _extends({
    defaultExpandAll: true
  }, props, {
    multiple: false,
    data: props.options,
    selectedKeys: keys,
    onSelected: onSelected
  }));
}
function SearchTree(props) {
  var {
      onChange,
      multiple = true,
      options = [],
      value = [],
      emptyOption = !options.length,
      treeProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var [selectedValues, selectedValuesSet] = useState(Array.isArray(value) ? value : [value]);
  var [selectedOptions, selectedOptionSet] = useState(options);
  var [isEmpty, isEmptySet] = useState(emptyOption);
  useEffect(() => {
    selectedValuesSet(Array.isArray(value) ? value : []);
  }, [JSON.stringify(value)]);
  var selectedChange = (resultValue, cur, isChecked) => {
    selectedValuesSet(resultValue);
    onChange == null || onChange(cur, resultValue, isChecked);
  };
  var selectedSearch = searchValue => {
    var hiddenNodeForSeach = function hiddenNodeForSeach(childrens, parentIsHide) {
      if (parentIsHide === void 0) {
        parentIsHide = true;
      }
      childrens.forEach(child => {
        var _child$children2;
        var isHide = !child.label.includes(searchValue.trim()) && parentIsHide;
        if (!!((_child$children2 = child.children) != null && _child$children2.length)) {
          hiddenNodeForSeach(child.children, isHide);
          var find = child.children.find(item => !item.hideNode);
          child.hideNode = isHide && !find;
        } else {
          child.hideNode = isHide;
        }
      });
    };
    hiddenNodeForSeach(options);
    selectedOptionSet([...options]);
    var isEmpt = true;
    options.forEach(opt => isEmpt = isEmpt && !!opt.hideNode);
    isEmptySet(typeof emptyOption === 'boolean' && isEmpt ? isEmpt : emptyOption);
  };
  return /*#__PURE__*/_jsx(SearchTagInput, _extends({}, other, {
    emptyOption: isEmpty,
    selectCloseDrop: !multiple,
    onSearch: selectedSearch,
    onChange: selectedChange,
    values: selectedValues,
    options: selectedOptions,
    content: multiple ? /*#__PURE__*/_jsx(TreeCheckeds, _extends({}, treeProps)) : /*#__PURE__*/_jsx(SingeTree, _extends({}, treeProps))
  }));
}
export default SearchTree;